/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { appSyncGraphQLApi } from '../../app/smorgAppSyncGraphQLApi';

export interface LoaderState {
  globalAppLoading: boolean;
}

const initialState: LoaderState = {
  globalAppLoading: false,
};

export const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    setGlobalLoading: (state) => {
      state.globalAppLoading = true;
    },
    cancelGlobalLoading: (state) => {
      state.globalAppLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(appSyncGraphQLApi.util.resetApiState, (state) => {
      state.globalAppLoading = false;
    });
  },
});

export const { setGlobalLoading, cancelGlobalLoading } = loaderSlice.actions;

export default loaderSlice.reducer;
